import { useState } from 'react'

export function useGretaAIChatChatListFrozenSections(
  liveSections,
  isChatListOrderFrozen
) {
  const [frozenSections, setFrozenSections] = useState(null)
  const [wasOrderFrozen, setWasOrderFrozen] = useState(isChatListOrderFrozen)

  if (isChatListOrderFrozen !== wasOrderFrozen) {
    setWasOrderFrozen(isChatListOrderFrozen)
    setFrozenSections(isChatListOrderFrozen ? liveSections : null)
  }

  return frozenSections ?? liveSections
}
